export default "__VITE_ASSET__79266683__"